<template>
  <div v-if="dataCenterVisible" class="data-center">
    <div class="header">
      <img class="header-bg" src="@/assets/data-center/header.png" />
      <div class="header-container">
        <div class="header-title">循电数智驭控中心</div>
        <div class="current-date">2024-09-07 周六 12:00:00</div>
        <div class="header-right">
          <div class="picker-box">
            <span>全国网点数据</span>
            <img class="picker-icon" src="@/assets/data-center/down.png" />
          </div>
          <img class="exit" src="@/assets/data-center/exit.png" @click="exit"/>
          <img class="exit" src="@/assets/data-center/exit.png" @click="toggleFullscreen"/>
        </div>
      </div>
    </div>

    <div class="layout">
      <div class="section">
        <layout-left></layout-left>
        <layout-center></layout-center>
        <layout-right></layout-right>
      </div>
      <layout-bottom></layout-bottom>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LayoutCenter from './components/layout-center.vue'
import LayoutLeft from './components/layout-left.vue'
import LayoutRight from './components/layout-right.vue'
import LayoutBottom from './components/layout-bottom.vue'

export default {
  components: {
    LayoutLeft,
    LayoutRight,
    LayoutCenter,
    LayoutBottom
  },

  data() {
    return {
      isFullscreen: false
    }
  },

  computed: {
    ...mapState({
      dataCenterVisible: (state) => state.app.dataCenterVisible
    })
  },

  created() {
    // document.body.style.overflow = 'hidden'
  },

  methods: {
    exit() {
      document.body.style.overflow = 'auto'
      this.$store.commit('SET_DATA_CENTER', false)
    },

    toggleFullscreen() {
      const element = document.documentElement;

      if (!this.isFullscreen) {
        // 进入全屏
        this.callFullscreenMethod(element, [
          'requestFullscreen',
          'webkitRequestFullscreen',
          'mozRequestFullScreen',
          'msRequestFullscreen',
        ]);
      } else {
        // 退出全屏
        this.callFullscreenMethod(document, [
          'exitFullscreen',
          'webkitExitFullscreen',
          'mozCancelFullScreen',
          'msExitFullscreen',
        ]);
      }

      this.isFullscreen = !this.isFullscreen;
    },

    callFullscreenMethod(element, methods) {
      for (const method of methods) {
        if (element[method]) {
          element[method]()
          break;
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.data-center {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  background-color: #090909;
  overflow-y: auto;

  .header {
    width: 100%;
    height: 72px;
    position: relative;
    .header-bg {
      width: 100%;
    }
    .header-container {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      .header-title {
        padding: 8px 0;
        font-size: 40px;
        font-weight: bold;
        text-align: center;
        color: #fff;
      }
      .current-date {
        position: absolute;
        left: 22px;
        bottom: 14px;
        font-size: 16px;
        font-weight: bold;
        color: #fff;
      }
      .header-right {
        position: absolute;
        right: 24px;
        bottom: 6px;
        display: flex;
        align-items: center;
        .picker-box {
          display: flex;
          align-items: center;
          padding: 10px;
          border-radius: 4px;
          background-color: #3C4254;
          font-size: 14px;
          font-weight: bold;
          color: #fff;
          cursor: pointer;
          .picker-icon {
            width: 8px;
            height: 7px;
            margin-left: 8px;
          }
        }
        .exit {
          width: 20px;
          height: 20px;
          margin-left: 16px;
          cursor: pointer;
        }
      }
    }
  }

  .layout {
    padding: 24px;
    .section {
      width: 100%;
      display: flex;
    }
  }
}
</style>
